/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Proposals API
 * Moment's Proposals API allows Clients to manage optimization proposals.
 * OpenAPI spec version: 1.0.0
 */

/**
 * The current status of the proposal.
 * running: The optimizer is currently running and has not yet generated proposed orders.
 * failed: The optimizer failed to generate proposed orders.
 * canceled: The user canceled the proposal before submitting it for execution.
 * in_review: The optimizer has generated proposed orders, and the user is now reviewing the orders prior to submitting them.
 * executing: The user has submitted the proposed orders, but they have not yet all reached a terminal state.
 * completed: The user has submitted the proposed orders and they have all reached a terminal state.
 * expired: The proposal has expired and needs to be re-ran.
 * view_only: A saved simulation. It cannot be executed, edited, canceled, or expired, and it does not block the account's other proposals.
 */
export type ProposalStatus = typeof ProposalStatus[keyof typeof ProposalStatus];


export const ProposalStatus = {
  running: 'running',
  failed: 'failed',
  canceled: 'canceled',
  in_review: 'in_review',
  executing: 'executing',
  completed: 'completed',
  expired: 'expired',
  view_only: 'view_only',
} as const;
